import * as ActionTypes from 'constants';
// import path from 'path';
// const dev_avatar_base_dir = path.resolve('../../dist/assets/images/avatars');

export const users = (state = {
	initializing : false,
	user : null,
	children : [],
	editing_user : false,
	creating_user : false,
	viewing_user : false,
	open_tab : '',
	password_tab_dirty : false,
	gen_info_tab_dirty : false,
	profile_pic_tab_dirty : false,
	show_delete_user_prompt : false,
	maps_initializing : false,
	avatars : [],
	tmp_user : null,
	tmp_user_roles : [],
	tmp_user_features : [],
	errors : [],
	proxy_account : null,
	proxy_children : null,
	fetching_temp_hash : false,
	resetting_password : false,
}, action) => {
	var {type, payload} = action;
	switch(action.type) {
		case ActionTypes.INIT_DASHBOARD_AVATARS:
			// if(process.env.NODE_ENV == 'local') {
			// 	const img_paths = payload
			// 	.map(p => path.join(dev_avatar_base_dir, p.split('/').filter(e => e != '').pop()));
			// 	return { ...state, avatars: img_paths };
			// }
			// else {
				return {...state, avatars: payload}
			// }
		case ActionTypes.UPDATE_USER_ERRORS:
			return {...state, errors : payload.errors};
		case ActionTypes.UPDATE_AUTHORIZED_USER:
			return {...state, user : {...state.user, ...payload.user}};
		case ActionTypes.FAVORITE_MAP_SUCCESS:
			return {...state, user: {...state.user, favorites: payload.favorites}}
		case ActionTypes.CLEAR_USER :
			return {...state, user : {}}
		case ActionTypes.SET_OPEN_TAB :
			return {...state, open_tab : payload}
		case ActionTypes.SET_PASSWORD_TAB_DIRTY :
			return {...state, password_tab_dirty : true}
		case ActionTypes.SET_GEN_INFO_TAB_DIRTY :
			return {...state, gen_info_tab_dirty : true}
		case ActionTypes.SET_PROFILE_PIC_TAB_DIRTY :
			return {...state, profile_pic_tab_dirty : true}
		case ActionTypes.ADD_USERS:
			var users = [];
			payload.users.forEach(user => {
				var found = false;
				for (var i = state.children.length - 1; i >= 0; i--) {
					if(state.children[i].user._id == user._id) {
						found = true;
						break;
					}
				};
				if(!found)
					users.push({user});
			})
			return {...state, children : [...state.children, ...users]}
		case ActionTypes.ADD_USER :
			var users = [];
			var {user} = payload;
			var found = false;

			for (var i = state.children.length - 1; i >= 0; i--) {
				if(state.children[i].user._id == user._id) {
					found = true;
					break;
				}
			};
			if(!found)
				users.push({user});

			return {...state, children : [...state.children, ...users]}
			break;
		case ActionTypes.EDIT_USER:
			if(state.proxy_account) {
				if(state.proxy_account._id === payload.user._id) {
					return {...state, proxy_account : {...payload.user}};
				}
				else {
					let index = (state.proxy_children ? state.proxy_children.find(c => c._id === payload._id) : -1)
					if(index >= 0) {
						return {
							...state, proxy_children : [
								...state.proxy_children.slice(0 , index),
								payload,
								...state.proxy_children.slice(index + 1)
							]
						}
					}
				}
			}
			if(state.user._id == payload.user._id)
				return {...state, user : {...state.user, ...payload.user}};
			var foundIndex = -1;
			for (var i = state.children.length - 1; i >= 0; i--) {
				if(state.children[i].user._id == payload.user._id)
				{
					foundIndex = i;
					break;
				}
			};
			if(foundIndex > -1) {
				var child = JSON.parse(JSON.stringify(state.children[foundIndex]));
				child.user = {...child.user, ...payload.user}
				return {
					...state,
					children : [
						...state.children.slice(0, foundIndex),
						child,
						...state.children.slice(foundIndex + 1, state.children.length)
					]
				}
			}
			else {
				return {
					...state,
					children : [...state.children, {user : payload.user}]
				}
			}
		case ActionTypes.SHOW_DELETE_USER_PROMPT :
			return {
				...state,
				show_delete_user_prompt : true,
				editing_user : false
			}
		case ActionTypes.HIDE_DELETE_USER_PROMPT :
			return {...state, show_delete_user_prompt : false}
		case ActionTypes.REMOVE_USER :
			let temp_children = state.children.filter(c => c.user._id != payload.user_id); // Remove deleted user
			payload.updatedChildren.forEach(child => {
				temp_children = temp_children.filter(c => c.user._id != child._id)
				temp_children = [...temp_children, {user : child}]
			})

			return {
				...state,
				children : temp_children,
				user : {
					...state.user,
					users_in_account : state.user.users_in_account ? state.user.users_in_account - 1 : 0
				}
			}

		case ActionTypes.SET_USER_PARENT:
			var indexOfUser = -1;
			var indexOfNewParent = -1;


			state.children.forEach((child, index) => {
				if(child.user._id == payload.user_id)
					indexOfUser = index;
				if(child.user._id == payload.parent_id)
					indexOfNewParent = index;
			});
			var user;
			var parent;

			if(indexOfUser > -1) {
				user = {...state.children[indexOfUser]};

				if(indexOfNewParent > -1)
					parent = {...state.children[indexOfNewParent]};
				else
					parent = {user : state.user}

				user.user.parent = parent.user._id;
				user.user.parents = [...parent.user.parents, parent.user._id];
				var stateChildren = [...state.children];
				for (var i = stateChildren.length - 1; i >= 0; i--) {
					for (var j = stateChildren[i].user.parents.length - 1; j >= 0; j--) {
						var parent = stateChildren[i].user.parents[j];
						if(parent == user.user._id) {

							stateChildren[i].user.parents = [...user.user.parents, ...stateChildren[i].user.parents.slice(j, stateChildren[i].user.parents.length)]
							break;
						}
					};
				};
				return {
					...state,
					children : [
						...stateChildren.slice(0, indexOfUser),
						user,
						...stateChildren.slice(indexOfUser + 1, state.children.length)
					]
				}
			}
			else
				return state;
			break;
		case ActionTypes.INIT_CHILDREN :
			return {...state, children : payload.map(c => ({user : c}))}
		case ActionTypes.UPDATE_TMP_USER:
			return {...state , tmp_user : payload.tmp_user};
		case ActionTypes.SHOW_CREATE_USER:
			return {...state, creating_user : true, tmp_user : {}};
		case ActionTypes.SHOW_EDIT_USER:
			return {...state, editing_user : true, tmp_user : payload.tmp_user};
		case ActionTypes.SHOW_VIEW_USER :
			return {...state, viewing_user : true, tmp_user : payload};
		case ActionTypes.HIDE_VIEW_USER :
			return {...state, viewing_user : payload, tmp_user : null	};
		case ActionTypes.HIDE_CREATE_USER:
			return {
				...state,
				creating_user : false,
				password_tab_dirty : false,
				gen_info_tab_dirty : false,
				profile_pic_tab_dirty : false,
				open_tab : '',
				tmp_user : null,
				errors : [],
			};
		case ActionTypes.HIDE_EDIT_USER:
			return {
				...state,
				editing_user : false,
				open_tab : '',
				errors : [],
			};
		case ActionTypes.ADD_CLIENT_TO_USER :
			if(!state.user.recently_viewed_clients) {
				return {...state, user : {...state.user, recently_viewed_clients : [payload]}}
			}
			else {
				let index = state.user.recently_viewed_clients.findIndex(c => {
					if(typeof c === 'string')
						return c === payload._id
					else if(typeof c === 'object' && c._id !== undefined)
						return c._id === payload._id
					else return false
				})

				if(index != -1) {
					return {...state, user : {...state.user, recently_viewed_clients : [
						payload, ...state.user.recently_viewed_clients.filter((e,i) => i !== index)
					]}}
				}
				else {
					return {...state, user : {...state.user, recently_viewed_clients : [
						payload , ...state.user.recently_viewed_clients
					]}}
				}
			}
		case ActionTypes.LOG_IN_PROXY_ACCOUNT :
			return {...state, logged_in_proxy : true, proxy_account : action.payload, viewing_user : false}
		case ActionTypes.LOG_OUT_PROXY_ACCOUNT :
			return {
				...state,
				logged_in_proxy : false,
				proxy_account : null,
				tmp_user_roles : [],
				tmp_user_features : []
			}
		case ActionTypes.UPDATE_PROXY_ACCOUNT :
			return {...state, proxy_account : payload}
		case ActionTypes.SET_TMP_USER_ROLES :
			return {...state, tmp_user_roles : payload}
		case ActionTypes.SET_TMP_USER_FEATURES :
			return {...state, tmp_user_features : payload}
		case ActionTypes.TOGGLE_MAPS_INIT_FLAG :
			return {...state, maps_initializing : payload ? payload : !state.maps_initializing}
		case ActionTypes.TOGGLE_FETCHING_TEMP_HASH :
			return {...state, fetching_temp_hash : payload !== undefined ? payload : !state.fetching_temp_hash}
		case ActionTypes.RESETING_PASSWORD :
			return {...state, resetting_password : payload !== undefined ? payload : !state.resetting_password}
		case ActionTypes.UPDATE_CUSTOMER: {
			return {
				...state,
				user: {
					...state.user,
					stripe: {
						...state.user.stripe,
						customer: action.customer
					}
				}
			}
		}
		default:
			return state;
		break;
	}
}



// WEBPACK FOOTER //
// ./src/common/reducers/users.js